module.exports = __webpack_public_path__ + "static/media/headerLogo.b23f715c.png";